<template>
  <div class="customState-effect">
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">
        Set
      </div>
      <el-select
        v-close-on-zoom
        :value="state.effect.id"
        placeholder="Custom State"
        class="customState-select"
        :disabled="readonly"
        @input="customStateId => selectCustomState(customStateId)"
      >
        <el-option
          v-for="customState in customStates"
          :key="customState.id"
          :label="customState.label"
          :value="customState.id"
        />
      </el-select>
      <div class="el-input-group__append el-input-group__prepend">
        to
      </div>
      <el-select
        v-close-on-zoom
        :value="state.effect.value"
        :disabled="readonly"
        @input="value => updateCustomStateValue(value)"
      >
        <el-option label="true" :value="true" />
        <el-option label="false" :value="false" />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-state-effect',
  props: ['states', 'readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {
          id: null,
          value: true,
        },
      },
      value: 0,
    };
  },
  computed: {
    customStates() {
      return this.emitter.caseConf.caseLogicDescription.customStates;
    },
  },
  mounted() {
    this.state.effect = this.getData(this.ikey) || this.state.effect;
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    selectCustomState(customStateId) {
      this.state.effect.id = customStateId;
      this.update();
    },
    updateCustomStateValue(value) {
      this.state.effect.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'CUSTOM_STATE',
        id: this.state.effect.id,
        value: this.state.effect.value,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.customState-select {
  width: 130px;
}

.customState-effect {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.duration-input {
  width: 125px;
}
</style>
